import { useContext } from "react";
import { I18nContext } from "./context";
import type { Translator } from "./translator";

export function useI18n(): Translator {
  const translator = useContext(I18nContext);
  if (!translator) throw new Error("useI18n must be used inside <I18nProvider>");
  return translator;
}
